import React, { useEffect, useState } from 'react'
import { NinetailedProvider } from '@ninetailed/experience.js-react'
import { NinetailedPreviewPlugin } from '@ninetailed/experience.js-plugin-preview'
import { NinetailedInsightsPlugin } from '@ninetailed/experience.js-plugin-insights'
import TrackPage from '@/components/track-page.tsx'

type NinetailedProviderWrapperProps = {
  allExperiences?: any[]
  allAudiences?: any[]
  children: React.ReactNode
  ninetailedClientId: string
  ninetailedEnv: string
}

export default function NinetailedProviderWrapper({
  allExperiences,
  allAudiences,
  children,
  ninetailedClientId,
  ninetailedEnv,
}: NinetailedProviderWrapperProps) {
  const [ninetailedReady, setNinetailed] = useState<any>()

  useEffect(() => {
    if (typeof window.ninetailed !== 'undefined') {
      setNinetailed(true)
    }
  }, [])
  return (
    <NinetailedProvider
      clientId={ninetailedClientId}
      environment={ninetailedEnv}
      plugins={[
        new NinetailedInsightsPlugin(),

        ...(ninetailedEnv !== 'main' && !import.meta.env.VITE_NINETAILED_PREVIEW_DISABLED
          ? [
              new NinetailedPreviewPlugin({
                experiences: allExperiences || [],
                audiences: allAudiences || [],
              }),
            ]
          : []),
      ]}
    >
      {ninetailedReady === true && <TrackPage />}
      {children}
    </NinetailedProvider>
  )
}
